function createFormSubscribeApi(getFormApi, getLogger) {
  const formSubscribers = /* @__PURE__ */ new Set();
  let notifyFormSubscribersPending;
  function notifyFormSubscribers() {
    const log = getLogger();
    if (!notifyFormSubscribersPending) {
      const formApi = getFormApi();
      notifyFormSubscribersPending = Promise.resolve().then(() => {
        log("notifyFormSubscribers");
        formSubscribers.forEach((subscriber) => {
          subscriber(formApi);
        });
        notifyFormSubscribersPending = void 0;
      });
    }
    return notifyFormSubscribersPending;
  }
  return { formSubscribers, notifyFormSubscribers };
}
export {
  createFormSubscribeApi
};
//# sourceMappingURL=createFormSubscribeApi.js.map
